module.exports = __webpack_public_path__ + "img/ukrpol_image_presentation.41ebd0f5.png";